import label from "@/lang/StaticLabels.js";

// PPARSINA Navbar  - پشتیبانی پارسینا  -----------------------------------------------
let navItems = [
  {
    title: label.modules.pbase,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PPARSINADashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: "PPARSINACompanyList",
    label: label.menu.company,
    metaLabel: label.page.company,
    icon: "mdi-warehouse",
    active: false,
    subItems: false,
  },
  {
    to: "PPARSINAMenu",
    label: label.menu.menuManagement,
    metaLabel: label.page.menuManagement,
    icon: "mdi-menu-open",
    active: false,
    subItems: false,
  },
  {
    to: "PPARSINARelationField",
    label: label.menu.relationField,
    metaLabel: label.page.relationField,
    icon: "mdi-relation-many-to-many",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.backup,
    icon: "mdi-database-cog-outline",
    active: false,
    subItems: [
      {
        to: "PPARSINABackupImport",
        label: label.menu.backupImport,
        metaLabel: label.page.backupImport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PPARSINABackupExport",
        label: label.menu.backupExport,
        metaLabel: label.page.backupExport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
